module.exports = __webpack_public_path__ + "img/base_nature_eolienne.55ab6b41.svg";